import { WSService } from "../../utils/WSService";

export const benefitsService = new WSService("/benefits");
